export default {
  path: 'roles',
  name: 'RolesList',
  component: () => import(/* webpackChunkName: "roles-list" */ '@/pages/sys_auth/roles/RolesList'),
  meta: {title:'角色管理'},
  children: [
    {
      path: ':role_id/manage-members',
      name: "RoleMembers",
      component: () => import(/* webpackChunkName: "manage-members" */ '@/pages/sys_auth/roles/ManageMembers'),
      meta: {title:'成员管理'},
    }
  ]
}
